webpackJsonp([114276838955818,60335399758886],{

/***/ 111:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"m1x","tagline":"I design and build apps for humans.","keywords":["hello","these","are","my","tags"]}}},"layoutContext":{}}

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(189);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(111);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(105);
	var isArguments = __webpack_require__(104);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 10:
/***/ (function(module, exports) {

	'use strict';
	
	var removeHash = function removeHash(hex) {
	  return hex.charAt(0) === '#' ? hex.slice(1) : hex;
	};
	
	var parseHex = function parseHex(nakedHex) {
	  var isShort = 3 === nakedHex.length || 4 === nakedHex.length;
	
	  var twoDigitHexR = isShort ? '' + nakedHex.slice(0, 1) + nakedHex.slice(0, 1) : nakedHex.slice(0, 2);
	  var twoDigitHexG = isShort ? '' + nakedHex.slice(1, 2) + nakedHex.slice(1, 2) : nakedHex.slice(2, 4);
	  var twoDigitHexB = isShort ? '' + nakedHex.slice(2, 3) + nakedHex.slice(2, 3) : nakedHex.slice(4, 6);
	  var twoDigitHexA = (isShort ? '' + nakedHex.slice(3, 4) + nakedHex.slice(3, 4) : nakedHex.slice(6, 8)) || 'ff';
	
	  // const numericA = +((parseInt(a, 16) / 255).toFixed(2));
	
	  return {
	    r: twoDigitHexR,
	    g: twoDigitHexG,
	    b: twoDigitHexB,
	    a: twoDigitHexA
	  };
	};
	
	var hexToDecimal = function hexToDecimal(hex) {
	  return parseInt(hex, 16);
	};
	
	var hexesToDecimals = function hexesToDecimals(_ref) {
	  var r = _ref.r,
	      g = _ref.g,
	      b = _ref.b,
	      a = _ref.a;
	  return {
	    r: hexToDecimal(r),
	    g: hexToDecimal(g),
	    b: hexToDecimal(b),
	    a: +(hexToDecimal(a) / 255).toFixed(2)
	  };
	};
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var formatRgb = function formatRgb(decimalObject, parameterA) {
	  var r = decimalObject.r,
	      g = decimalObject.g,
	      b = decimalObject.b,
	      parsedA = decimalObject.a;
	
	  var a = isNumeric(parameterA) ? parameterA : parsedA;
	
	  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
	};
	
	/**
	 * Turns an old-fashioned css hex color value into a rgb color value.
	 *
	 * If you specify an alpha value, you'll get a rgba() value instead.
	 *
	 * @param The hex value to convert. ('123456'. '#123456', ''123', '#123')
	 * @param An alpha value to apply. (optional) ('0.5', '0.25')
	 * @return An rgb or rgba value. ('rgb(11, 22, 33)'. 'rgba(11, 22, 33, 0.5)')
	 */
	var hexToRgba = function hexToRgba(hex, a) {
	  var hashlessHex = removeHash(hex);
	  var hexObject = parseHex(hashlessHex);
	  var decimalObject = hexesToDecimals(hexObject);
	
	  return formatRgb(decimalObject, a);
	};
	
	module.exports = hexToRgba;

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(117);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(103);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(113);
	
	var _HelmetConstants = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(74);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(107));
	var shallowEqual = _interopDefault(__webpack_require__(118));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  bottom: 1rem;\n  left: 3rem;\n'], ['\n  position: fixed;\n  bottom: 1rem;\n  left: 3rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.footer(_templateObject);
	
	var Footer = function Footer(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    Container,
	    null,
	    children
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: 1.25rem;\n  font-weight: ', ';\n'], ['\n  font-size: 1.25rem;\n  font-weight: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  text-decoration: none;\n\n  @media screen and (min-width: ', ') {\n    transition: background-color 150ms ease-in-out;\n    border-radius: ', ';\n    background-color: transparent;\n    margin-left: -', ';\n    padding: ', ' ', ';\n\n    &:hover {\n      color: ', ';\n      background-color: rgba(', ', 0.1);\n    }\n  }\n'], ['\n  color: ', ';\n  text-decoration: none;\n\n  @media screen and (min-width: ', ') {\n    transition: background-color 150ms ease-in-out;\n    border-radius: ', ';\n    background-color: transparent;\n    margin-left: -', ';\n    padding: ', ' ', ';\n\n    &:hover {\n      color: ', ';\n      background-color: rgba(', ', 0.1);\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheming = __webpack_require__(4);
	
	var _styledTheming2 = _interopRequireDefault(_styledTheming);
	
	var _outerContainer = __webpack_require__(22);
	
	var _routes = __webpack_require__(16);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _styles = __webpack_require__(3);
	
	var _logo = __webpack_require__(169);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _navigation = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Styles
	// ----------------------------------------
	
	var color = _styles.myTheme.color,
	    fontWeight = _styles.myTheme.fontWeight,
	    breakpoint = _styles.myTheme.breakpoint,
	    space = _styles.myTheme.space,
	    borderRadii = _styles.myTheme.borderRadii;
	
	
	var linkColor = (0, _styledTheming2.default)('mode', {
	  light: color.text,
	  dark: color.white
	});
	
	// About Site
	// ----------------------------------------
	
	var SiteTitle = _styledComponents2.default.h1(_templateObject, fontWeight.four);
	var StyledLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject2, linkColor, breakpoint.medium, borderRadii.two, space.one, space.half, space.one, _styles.themedTextColor, _styles.themedTextColorRgb);
	
	var Header = function Header(_ref) {
	  var title = _ref.title;
	  return _react2.default.createElement(
	    _outerContainer.OuterContainer,
	    { className: 'flex mb1 md-mb2 py3' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'flex items-center' },
	        _react2.default.createElement(
	          SiteTitle,
	          { className: 'm0' },
	          _react2.default.createElement(
	            StyledLink,
	            {
	              color: 'text',
	              to: _routes2.default.home
	            },
	            title
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _navigation.Navigation,
	        null,
	        _react2.default.createElement(
	          _navigation.NavigationItem,
	          { to: _routes2.default.about },
	          'About'
	        ),
	        _react2.default.createElement(
	          _navigation.NavigationItem,
	          { to: _routes2.default.works },
	          'Works'
	        ),
	        _react2.default.createElement(
	          _navigation.NavigationItem,
	          { to: _routes2.default.writing },
	          'Writing'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'ml-auto' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: _routes2.default.home },
	        _react2.default.createElement(_logo2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _header = __webpack_require__(167);
	
	var _header2 = _interopRequireDefault(_header);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _header2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var A11yDescription = function A11yDescription(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'span',
	    { className: 'hide' },
	    children
	  );
	};
	
	exports.default = A11yDescription;
	module.exports = exports['default'];

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.A11yDescription = undefined;
	
	var _outerContainer = __webpack_require__(22);
	
	Object.keys(_outerContainer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _outerContainer[key];
	    }
	  });
	});
	
	var _a11yDescription = __webpack_require__(35);
	
	var _a11yDescription2 = _interopRequireDefault(_a11yDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.A11yDescription = _a11yDescription2.default;

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NegateOuterContainer = exports.OuterContainer = undefined;
	
	var _outerContainer = __webpack_require__(38);
	
	var _outerContainer2 = _interopRequireDefault(_outerContainer);
	
	var _negateOuterContainer = __webpack_require__(37);
	
	var _negateOuterContainer2 = _interopRequireDefault(_negateOuterContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.OuterContainer = _outerContainer2.default;
	exports.NegateOuterContainer = _negateOuterContainer2.default;

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', ';\n  ', ';\n'], ['\n  ', ';\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  @mediaQueryTarget screen and (min-width: ', ') {\n    ', ';\n    ', ';\n  }\n'], ['\n  @mediaQueryTarget screen and (min-width: ', ') {\n    ', ';\n    ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  @media screen and (min-width: ', ') {\n    ', ';\n    ', ';\n  }\n'], ['\n  @media screen and (min-width: ', ') {\n    ', ';\n    ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var space = _styles.myTheme.space,
	    breakpoint = _styles.myTheme.breakpoint;
	
	/*
	  Negate's the parent OuterContainer
	
	  Usage:
	
	  One Side:
	    <NegateOuterContainer
	      side="left|right|both (default)
	      breakpoint={breakpoint.small}
	    >
	      <Element />
	    </div>
	
	  Both Sides:
	    <NegateOuterContainer>
	      <Element />
	    </div>
	
	*/
	
	var Base = _styledComponents2.default.div(_templateObject, function (props) {
	  return (props.side === 'left' || props.side === 'both') && 'margin-left: -' + space.three + ';';
	}, function (props) {
	  return (props.side === 'right' || props.side === 'both') && 'margin-right: -' + space.three + ';';
	});
	var Small = _styledComponents2.default.div(_templateObject2, breakpoint.small, function (props) {
	  return (props.side === 'left' || props.side === 'both') && 'margin-left: -' + space.three + ';';
	}, function (props) {
	  return (props.side === 'right' || props.side === 'both') && 'margin-right: -' + space.three + ';';
	});
	var Medium = _styledComponents2.default.div(_templateObject3, breakpoint.medium, function (props) {
	  return (props.side === 'left' || props.side === 'both') && 'margin-left: -' + space.four + ';';
	}, function (props) {
	  return (props.side === 'right' || props.side === 'both') && 'margin-right: -' + space.four + ';';
	});
	var Large = _styledComponents2.default.div(_templateObject3, breakpoint.large, function (props) {
	  return (props.side === 'left' || props.side === 'both') && 'margin-left: -' + space.five + ';';
	}, function (props) {
	  return (props.side === 'right' || props.side === 'both') && 'margin-right: -' + space.five + ';';
	});
	
	var NegateOuterContainer = function NegateOuterContainer(_ref) {
	  var side = _ref.side,
	      children = _ref.children,
	      mediaQueryTarget = _ref.mediaQueryTarget;
	
	  if (mediaQueryTarget === 'small') {
	    return _react2.default.createElement(
	      Small,
	      { side: side },
	      children
	    );
	  } else if (mediaQueryTarget === 'medium') {
	    return _react2.default.createElement(
	      Medium,
	      { side: side },
	      children
	    );
	  } else if (mediaQueryTarget === 'large') {
	    return _react2.default.createElement(
	      Large,
	      { side: side },
	      children
	    );
	  }
	  return _react2.default.createElement(
	    Base,
	    { side: side },
	    children
	  );
	};
	NegateOuterContainer.defaultProps = {
	  side: 'both',
	  mediaQueryTarget: 0
	};
	
	exports.default = NegateOuterContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OuterContainer = function OuterContainer(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('px3 sm-px4 md-px5', className) },
	    children
	  );
	};
	
	exports.default = OuterContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: ', ';\n  background-color: transparent;\n  border-radius: ', ';\n  transition-property: background-color, transform;\n  transition-duration: 150ms;\n  transition-timing-function: ease-in;\n\n  &:active {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n\n  @media screen and (min-width: ', ') {\n    &:hover [data-line-identifier=\'yShape\'] {\n      transform: rotate(178deg);\n    }\n    &:hover [data-line-identifier=\'xShape\'] {\n      transform: rotate(142deg);\n    }\n  }\n'], ['\n  padding: ', ';\n  background-color: transparent;\n  border-radius: ', ';\n  transition-property: background-color, transform;\n  transition-duration: 150ms;\n  transition-timing-function: ease-in;\n\n  &:active {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n\n  @media screen and (min-width: ', ') {\n    &:hover [data-line-identifier=\'yShape\'] {\n      transform: rotate(178deg);\n    }\n    &:hover [data-line-identifier=\'xShape\'] {\n      transform: rotate(142deg);\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  top: 2px;\n'], ['\n  position: relative;\n  top: 2px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  transform-origin: center center;\n  transition: transform 250ms ease-in-out;\n'], ['\n  transform-origin: center center;\n  transition: transform 250ms ease-in-out;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  mix-blend-mode: ', ';\n'], ['\n  mix-blend-mode: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  transform: rotate(150deg);\n'], ['\n  transform: rotate(150deg);\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  transform: rotate(170deg);\n'], ['\n  transform: rotate(170deg);\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheming = __webpack_require__(4);
	
	var _styledTheming2 = _interopRequireDefault(_styledTheming);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Styles
	// ----------------------------------------
	
	var color = _styles.myTheme.color,
	    space = _styles.myTheme.space,
	    borderRadii = _styles.myTheme.borderRadii,
	    breakpoint = _styles.myTheme.breakpoint;
	
	
	var mixBlendMode = (0, _styledTheming2.default)('mode', {
	  light: 'darken',
	  dark: 'lighten'
	});
	
	// Container
	// ----------------------------------------
	
	var SVGWrap = _styledComponents2.default.div(_templateObject, space.half, borderRadii.three, breakpoint.medium);
	
	var SVG = _styledComponents2.default.svg(_templateObject2);
	
	// This is the individual lines from the logo. (extend)
	var ShapeContainer = _styledComponents2.default.g(_templateObject3);
	
	// Shape
	// ----------------------------------------
	
	var Line = _styledComponents2.default.rect(_templateObject4, mixBlendMode);
	var XContainer = ShapeContainer.extend(_templateObject5);
	var YContainer = ShapeContainer.extend(_templateObject6);
	
	var Logo = function Logo(_ref) {
	  var className = _ref.className,
	      xShapeFill = _ref.xShapeFill,
	      yShapeFill = _ref.yShapeFill;
	  return _react2.default.createElement(
	    SVGWrap,
	    { className: className },
	    _react2.default.createElement(
	      SVG,
	      {
	        xmlns: 'http://www.w3.org/2000/svg',
	        width: '42',
	        height: '42'
	      },
	      _react2.default.createElement(
	        'g',
	        {
	          fill: 'none',
	          fillRule: 'evenodd'
	        },
	        _react2.default.createElement(
	          XContainer,
	          { 'data-line-identifier': 'xShape' },
	          _react2.default.createElement(Line, {
	            width: '42',
	            height: '3',
	            y: '19.5',
	            fill: xShapeFill,
	            rx: '1.5'
	          })
	        ),
	        _react2.default.createElement(
	          YContainer,
	          { 'data-line-identifier': 'yShape' },
	          _react2.default.createElement(Line, {
	            width: '3',
	            height: '42',
	            x: '19.5',
	            fill: yShapeFill,
	            rx: '1.5'
	          })
	        )
	      )
	    )
	  );
	};
	Logo.defaultProps = {
	  className: '',
	  xShapeFill: color.strongPurple,
	  yShapeFill: color.cyan
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NavigationLinkActive = exports.NavigationLink = exports.NavigationItem = exports.Navigation = undefined;
	
	var _navigation = __webpack_require__(40);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _navigationItem = __webpack_require__(39);
	
	var _navigationItem2 = _interopRequireDefault(_navigationItem);
	
	var _navigationLink = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Navigation = _navigation2.default;
	exports.NavigationItem = _navigationItem2.default;
	exports.NavigationLink = _navigationLink.NavigationLink;
	exports.NavigationLinkActive = _navigationLink.NavigationLinkActive;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n\n  &:not(:last-child) {\n    margin-right: ', ';\n  }\n'], ['\n  font-size: ', ';\n\n  &:not(:last-child) {\n    margin-right: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _navigationLink = __webpack_require__(15);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var space = _styles.myTheme.space,
	    fontSize = _styles.myTheme.fontSize;
	
	
	var ListItem = _styledComponents2.default.li(_templateObject, fontSize.six, space.two);
	
	var NavigationItem = function NavigationItem(_ref) {
	  var to = _ref.to,
	      children = _ref.children;
	  return _react2.default.createElement(
	    ListItem,
	    null,
	    _react2.default.createElement(
	      _navigationLink.NavigationLink,
	      { to: to },
	      children
	    )
	  );
	};
	
	exports.default = NavigationItem;
	module.exports = exports['default'];

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NavigationLinkActive = exports.NavigationLink = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-decoration: none;\n  color: ', ';\n  transition: all 150ms ease-in-out;\n  font-weight: ', ';\n  border-bottom: 2px solid transparent;\n\n  &:hover {\n    color: ', ';\n  }\n\n  &.', ' {\n    color: ', ';\n    border-bottom: 2px solid rgba(', ', 0.2);\n  }\n'], ['\n  text-decoration: none;\n  color: ', ';\n  transition: all 150ms ease-in-out;\n  font-weight: ', ';\n  border-bottom: 2px solid transparent;\n\n  &:hover {\n    color: ', ';\n  }\n\n  &.', ' {\n    color: ', ';\n    border-bottom: 2px solid rgba(', ', 0.2);\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheming = __webpack_require__(4);
	
	var _styledTheming2 = _interopRequireDefault(_styledTheming);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var color = _styles.myTheme.color,
	    fontWeight = _styles.myTheme.fontWeight;
	
	
	var NavigationLinkActive = '_nav-item-is-active';
	var linkColor = (0, _styledTheming2.default)('mode', {
	  dark: color.darkSilver,
	  light: color.lightBlueGray
	});
	
	var StyledLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject, linkColor, fontWeight.five, _styles.themedTextColor, NavigationLinkActive, _styles.themedTextColor, _styles.themedTextColorRgb);
	
	var NavigationLink = function NavigationLink(_ref) {
	  var children = _ref.children,
	      to = _ref.to,
	      activeClassName = _ref.activeClassName;
	  return _react2.default.createElement(
	    StyledLink,
	    {
	      to: to,
	      activeClassName: activeClassName
	    },
	    children
	  );
	};
	NavigationLink.defaultProps = {
	  activeClassName: NavigationLinkActive
	};
	
	exports.NavigationLink = NavigationLink;
	exports.NavigationLinkActive = NavigationLinkActive;

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  list-style: none;\n  padding-left: 0;\n'], ['\n  list-style: none;\n  padding-left: 0;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var List = _styledComponents2.default.ul(_templateObject);
	
	var Navigation = function Navigation(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'nav',
	    null,
	    _react2.default.createElement(
	      List,
	      { className: 'flex' },
	      children
	    )
	  );
	};
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: none; /* hides checkbox visually */\n'], ['\n  display: none; /* hides checkbox visually */\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  background-color: transparent;\n  border-radius: ', ';\n  display: flex;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n\n  transition: background-color 200ms ease-in-out;\n\n  /* Hides inner icon before entrering frame (from animation) */\n  overflow: hidden;\n\n  @media screen and (min-width: 0) and (max-width: ', ') {\n    background-color: ', ';\n\n    @supports (backdrop-filter: blur(20px)) {\n      background-color: ', ';\n      backdrop-filter: blur(20px);\n    }\n  }\n\n  @media screen and (min-width: ', ') {\n    background-color: transparent;\n\n    &:hover {\n      background-color: ', ';\n    }\n  }\n'], ['\n  align-items: center;\n  background-color: transparent;\n  border-radius: ', ';\n  display: flex;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n\n  transition: background-color 200ms ease-in-out;\n\n  /* Hides inner icon before entrering frame (from animation) */\n  overflow: hidden;\n\n  @media screen and (min-width: 0) and (max-width: ', ') {\n    background-color: ', ';\n\n    @supports (backdrop-filter: blur(20px)) {\n      background-color: ', ';\n      backdrop-filter: blur(20px);\n    }\n  }\n\n  @media screen and (min-width: ', ') {\n    background-color: transparent;\n\n    &:hover {\n      background-color: ', ';\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n'], ['\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  /*\n    If the user clicks a bunch of times the text will highlight.\n    IMO, this isn\'t a great user experience so I\'ve disabled this\n    native interaction.\n  */\n  user-select: none;\n\n  /* Moves Icons down a pixel so it\'s visually centered */\n  position: relative;\n  top: 0.0625rem;\n'], ['\n  /*\n    If the user clicks a bunch of times the text will highlight.\n    IMO, this isn\'t a great user experience so I\'ve disabled this\n    native interaction.\n  */\n  user-select: none;\n\n  /* Moves Icons down a pixel so it\'s visually centered */\n  position: relative;\n  top: 0.0625rem;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  animation-name: ', ';\n  animation-timing-function: ease-out;\n  animation-duration: 300ms;\n  animation-delay: 250ms;\n  animation-fill-mode: both;\n'], ['\n  animation-name: ', ';\n  animation-timing-function: ease-out;\n  animation-duration: 300ms;\n  animation-delay: 250ms;\n  animation-fill-mode: both;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheming = __webpack_require__(4);
	
	var _styledTheming2 = _interopRequireDefault(_styledTheming);
	
	var _hexToRgba = __webpack_require__(10);
	
	var _hexToRgba2 = _interopRequireDefault(_hexToRgba);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Styles
	// ----------------------------------------
	
	var color = _styles.myTheme.color,
	    borderRadii = _styles.myTheme.borderRadii,
	    breakpoint = _styles.myTheme.breakpoint;
	
	
	var buttonBackground = {
	  mobile: {
	    default: (0, _styledTheming2.default)('mode', {
	      light: (0, _hexToRgba2.default)(color.white, 0.8),
	      dark: (0, _hexToRgba2.default)(color.darkBlueGray, 0.8)
	    }),
	    supportsBackdropFilter: (0, _styledTheming2.default)('mode', {
	      light: (0, _hexToRgba2.default)(color.white, 0.2),
	      dark: (0, _hexToRgba2.default)(color.darkBlueGray, 0.2)
	    })
	  },
	  greaterThanMobile: (0, _styledTheming2.default)('mode', {
	    light: (0, _hexToRgba2.default)(color.black, 0.05),
	    dark: (0, _hexToRgba2.default)(color.white, 0.05)
	  })
	};
	
	var Checkbox = _styledComponents2.default.input(_templateObject);
	var WrapperLabel = _styledComponents2.default.label(_templateObject2, borderRadii.three, breakpoint.medium, buttonBackground.mobile.default, buttonBackground.mobile.supportsBackdropFilter, breakpoint.medium, buttonBackground.greaterThanMobile);
	var moveIn = (0, _styledComponents.keyframes)(_templateObject3);
	var IconWrapper = _styledComponents2.default.div(_templateObject4);
	var Animation = _styledComponents2.default.div(_templateObject5, moveIn);
	
	var DayIcon = function DayIcon(_ref) {
	  var fill = _ref.fill;
	  return _react2.default.createElement(
	    Animation,
	    null,
	    _react2.default.createElement(
	      'svg',
	      {
	        xmlns: 'http://www.w3.org/2000/svg',
	        width: '25',
	        height: '25'
	      },
	      _react2.default.createElement('path', {
	        fill: fill
	        /* eslint-disable max-len */
	        , d: 'M14.64 13.5l.93.37c-.2.49-.5.93-.89 1.28-.59.55-1.37.85-2.18.85-.82 0-1.57-.3-2.18-.87-.38-.34-.68-.78-.87-1.26l.93-.37c.14.34.35.65.62.9.85.79 2.19.77 3.01.01.28-.25.49-.56.63-.91zM11.01 12h1c0-1.1-.9-2-2-2s-2 .9-2 2h1c0-.55.45-1 1-1s1 .45 1 1zm2 0h1c0-.55.45-1 1-1s1 .45 1 1h1c0-1.1-.9-2-2-2s-2 .9-2 2zm12 .5c0 .34-.22.64-.55.74a5.114 5.114 0 0 0-3.56 4.89c0 .77.17 1.52.5 2.21.15.31.09.66-.15.9a.79.79 0 0 1-.9.15c-.69-.33-1.44-.5-2.21-.5-2.24 0-4.21 1.43-4.89 3.56-.1.33-.4.55-.74.55-.34 0-.64-.22-.75-.55a5.114 5.114 0 0 0-4.89-3.56c-.77 0-1.52.17-2.21.5-.31.15-.66.09-.9-.15a.775.775 0 0 1-.15-.9c.33-.7.5-1.44.5-2.21 0-2.24-1.43-4.21-3.56-4.89-.33-.1-.55-.4-.55-.74 0-.34.22-.64.55-.75a5.114 5.114 0 0 0 3.56-4.89c0-.77-.17-1.52-.5-2.21a.775.775 0 0 1 .15-.9.79.79 0 0 1 .9-.15c.7.34 1.44.51 2.21.51 2.24 0 4.21-1.43 4.89-3.56.1-.33.4-.55.74-.55.34 0 .64.22.75.55a5.114 5.114 0 0 0 4.89 3.56c.77 0 1.52-.17 2.21-.51.31-.15.66-.09.9.15s.3.59.15.9c-.33.7-.5 1.44-.5 2.21 0 2.24 1.43 4.21 3.56 4.89.33.11.55.41.55.75zm-1.41 0a6.107 6.107 0 0 1-3.7-5.63c0-.74.13-1.46.39-2.14-.68.26-1.4.39-2.14.39-2.48 0-4.67-1.47-5.63-3.7a6.107 6.107 0 0 1-5.63 3.7c-.74 0-1.46-.13-2.14-.39.26.68.39 1.4.39 2.14 0 2.48-1.47 4.67-3.7 5.63 2.24.96 3.7 3.16 3.7 5.63 0 .74-.13 1.46-.39 2.14.68-.26 1.4-.39 2.14-.39 2.48 0 4.67 1.47 5.63 3.7.96-2.24 3.16-3.7 5.63-3.7.74 0 1.46.13 2.14.39-.26-.68-.39-1.4-.39-2.14 0-2.47 1.46-4.67 3.7-5.63zm-4.59 0c0 3.58-2.92 6.5-6.5 6.5s-6.5-2.92-6.5-6.5S8.93 6 12.51 6s6.5 2.92 6.5 6.5zm-1 0c0-3.03-2.47-5.5-5.5-5.5a5.51 5.51 0 0 0-5.5 5.5c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5z'
	        /* eslint-enable max-len */
	      })
	    )
	  );
	};
	DayIcon.defaultProps = {
	  fill: color.darkSilver
	};
	var NightIcon = function NightIcon(_ref2) {
	  var fill = _ref2.fill;
	  return _react2.default.createElement(
	    Animation,
	    null,
	    _react2.default.createElement(
	      'svg',
	      {
	        xmlns: 'http://www.w3.org/2000/svg',
	        width: '23',
	        height: '23'
	      },
	      _react2.default.createElement('path', {
	        fill: fill
	        /* eslint-disable max-len */
	        , d: 'M12.062 22.99c-6.651 0-12.06-5.4-12.06-12.033 0-4.977 2.566-9.062 6.862-10.92a.468.468 0 0 1 .516.101c.138.138.165.34.082.516a11.061 11.061 0 0 0-1.076 4.793c0 6.154 5.014 11.168 11.168 11.168 1.675 0 3.294-.368 4.794-1.076a.463.463 0 0 1 .515.082c.138.13.174.34.1.516-1.867 4.287-5.942 6.853-10.9 6.853zM6.147 1.417C2.853 3.312.92 6.8.92 10.957c0 6.127 4.996 11.113 11.141 11.113 4.15 0 7.618-1.932 9.513-5.225-1.288.46-2.64.69-4.03.69-6.67 0-12.088-5.419-12.088-12.088 0-1.39.23-2.742.69-4.03zm8.206 9.614a.454.454 0 0 1-.442-.589l1.104-3.615-2.88-2.3a.46.46 0 0 1 .286-.82h3.533L17.048.314c.12-.377.755-.377.874 0l1.095 3.395h3.533c.193 0 .368.12.432.303a.463.463 0 0 1-.147.516l-2.88 2.309 1.105 3.523a.459.459 0 0 1-.166.506.442.442 0 0 1-.534 0l-2.852-2.051-2.86 2.125a.526.526 0 0 1-.295.092zm1.481-4.729c.147.12.212.313.157.497l-.782 2.576 2.005-1.49a.455.455 0 0 1 .543 0l2.005 1.444-.782-2.502a.45.45 0 0 1 .157-.497l2.107-1.684h-2.558a.464.464 0 0 1-.442-.322L17.49 1.97l-.754 2.355a.464.464 0 0 1-.442.322h-2.557l2.097 1.656z'
	        /* eslint-enable max-len */
	      })
	    )
	  );
	};
	NightIcon.defaultProps = {
	  fill: color.lightBlueGray
	};
	
	var ThemeToggle = function ThemeToggle(_ref3) {
	  var onClick = _ref3.onClick,
	      id = _ref3.id,
	      className = _ref3.className,
	      nightMode = _ref3.nightMode;
	  return _react2.default.createElement(
	    WrapperLabel,
	    {
	      htmlFor: id,
	      className: className
	    },
	    _react2.default.createElement(Checkbox, {
	      id: id,
	      onClick: onClick,
	      type: 'checkbox'
	    }),
	    _react2.default.createElement(
	      IconWrapper,
	      null,
	      nightMode ? _react2.default.createElement(DayIcon, null) : _react2.default.createElement(NightIcon, null)
	    )
	  );
	};
	ThemeToggle.defaultProps = {
	  className: ''
	};
	
	exports.default = ThemeToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: ', ';\n  color: ', ';\n'], ['\n  max-width: ', ';\n  color: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  bottom: ', ';\n  right: ', ';\n'], ['\n  position: fixed;\n  bottom: ', ';\n  right: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(112);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheming = __webpack_require__(4);
	
	var _styledTheming2 = _interopRequireDefault(_styledTheming);
	
	var _header = __webpack_require__(168);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _themeToggle = __webpack_require__(170);
	
	var _themeToggle2 = _interopRequireDefault(_themeToggle);
	
	var _helpers = __webpack_require__(36);
	
	var _footer = __webpack_require__(166);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _works = __webpack_require__(49);
	
	var _styles = __webpack_require__(3);
	
	var _routes = __webpack_require__(16);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	__webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var space = _styles.myTheme.space,
	    color = _styles.myTheme.color;
	
	// Styles
	// ----------------------------------------
	
	var bodyTextColor = (0, _styledTheming2.default)('mode', {
	  light: color.text,
	  dark: color.white
	});
	
	var Content = (0, _styledComponents2.default)(_helpers.OuterContainer)(_templateObject, _styles.stylesConfig.contentMaxWidth, bodyTextColor);
	
	var ThemeToggleContainer = _styledComponents2.default.div(_templateObject2, space.two, space.two);
	
	// localStorage key
	var UserPreferenceMode = 'user_ui_mode';
	
	// Flow Typing
	// ----------------------------------------
	
	var IndexLayout = function (_PureComponent) {
	  _inherits(IndexLayout, _PureComponent);
	
	  function IndexLayout() {
	    _classCallCheck(this, IndexLayout);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	    _this.state = {
	      mode: 'dark',
	      loading: true
	    };
	    return _this;
	  }
	
	  IndexLayout.prototype.componentDidMount = function componentDidMount() {
	    var localUIPreferenceMode = localStorage.getItem(UserPreferenceMode);
	    var hasPresetUIPreference = !!localUIPreferenceMode;
	    var themeMode = hasPresetUIPreference ? localUIPreferenceMode : 'dark';
	
	    // Set localStorage when component mounts
	    if (themeMode === null || themeMode === undefined) {
	      localStorage.setItem(UserPreferenceMode, 'dark');
	    } else {
	      localStorage.setItem(UserPreferenceMode, themeMode);
	    }
	
	    /* eslint-disable react/no-did-mount-set-state */
	
	    // This triggers a re-render which is unfortunate... but the only way to
	    // solve that problem would be to re-write the SSR config and that's just
	    // not MVP. ¯\_(ツ)_/¯
	    //
	    // Known Issues:
	    // Since we're not setting the background color of the body until after
	    // initial render there's a slight flash if the user preference is set
	    // to light mode on intial load or refresh.
	
	    // Set state based on localStorage
	    this.setState({
	      mode: themeMode,
	      loading: false
	    });
	    /* eslint-enable */
	  };
	
	  IndexLayout.prototype.handleThemeChange = function handleThemeChange() {
	    var switchMode = this.state.mode === 'dark' ? 'light' : 'dark';
	
	    this.setState({ mode: switchMode });
	    localStorage.setItem(UserPreferenceMode, switchMode);
	  };
	
	  IndexLayout.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data,
	        location = _props.location;
	    var loading = this.state.loading;
	
	    // Destructure data from query
	
	    var _data$site$siteMetada = data.site.siteMetadata,
	        title = _data$site$siteMetada.title,
	        tagline = _data$site$siteMetada.tagline,
	        keywords = _data$site$siteMetada.keywords;
	
	
	    var isWorksPage = location.pathname === _routes2.default.erbConnect || location.pathname === _routes2.default.mavenPro;
	
	    // Loading
	    if (loading) {
	      return null;
	    }
	
	    var isDarkTheme = this.state.mode === 'dark';
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: { mode: this.state.mode } },
	      _react2.default.createElement(
	        'div',
	        { className: 'sans-serif' },
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          {
	            title: title,
	            meta: [{ name: 'description', content: tagline }, { name: 'keywords', content: keywords }]
	          },
	          _react2.default.createElement('html', { lang: 'en' }),
	          _react2.default.createElement('body', {
	            className: this.state.mode === 'light' ? 'js-light-theme' : 'js-dark-theme'
	          })
	        ),
	        _react2.default.createElement(_header2.default, {
	          title: title,
	          subtitle: tagline
	        }),
	        _react2.default.createElement(
	          Content,
	          { className: 'pt0 px2 pb3' },
	          children(),
	          isWorksPage && _react2.default.createElement(_works.WorksNavigation, { disabled: true })
	        ),
	        _react2.default.createElement(
	          _footer2.default,
	          null,
	          _react2.default.createElement(
	            ThemeToggleContainer,
	            null,
	            _react2.default.createElement(_themeToggle2.default, {
	              id: 'theme-toggle',
	              onClick: function onClick() {
	                return _this2.handleThemeChange();
	              },
	              nightMode: isDarkTheme
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return IndexLayout;
	}(_react.PureComponent);
	
	// $FlowFixMe
	
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = IndexLayout;

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n\n  @media screen and (min-width: ', ') {\n    font-size: ', ';\n  }\n'], ['\n  font-size: ', ';\n\n  @media screen and (min-width: ', ') {\n    font-size: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-weight: ', ';\n'], ['\n  color: ', ';\n  font-weight: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__(12);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var color = _styles.myTheme.color,
	    fontSize = _styles.myTheme.fontSize,
	    fontWeight = _styles.myTheme.fontWeight,
	    breakpoint = _styles.myTheme.breakpoint;
	
	
	var Title = _styledComponents2.default.h1(_templateObject, fontSize.two, breakpoint.large, fontSize.one);
	
	var Subtitle = _styledComponents2.default.p(_templateObject2, color.darkSilver, fontWeight.five);
	
	var Head = function Head(_ref) {
	  var title = _ref.title,
	      tags = _ref.tags;
	
	  var formatTags = tags.join(', ');
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _typography.Headline,
	      null,
	      _react2.default.createElement(
	        Title,
	        { className: 'mb1' },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      Subtitle,
	      { className: 'mb3 mt0' },
	      formatTags
	    )
	  );
	};
	
	exports.default = Head;
	module.exports = exports['default'];

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.WorksNavigation = exports.Head = undefined;
	
	var _head = __webpack_require__(48);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _worksNavigation = __webpack_require__(50);
	
	var _worksNavigation2 = _interopRequireDefault(_worksNavigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Head = _head2.default;
	exports.WorksNavigation = _worksNavigation2.default;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: ', ';\n  border-top: 1px solid ', ';\n  display: ', ';\n'], ['\n  margin-top: ', ';\n  border-top: 1px solid ', ';\n  display: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheming = __webpack_require__(4);
	
	var _styledTheming2 = _interopRequireDefault(_styledTheming);
	
	var _navigation = __webpack_require__(23);
	
	var _routes = __webpack_require__(16);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var color = _styles.myTheme.color,
	    space = _styles.myTheme.space;
	
	
	var borderColor = (0, _styledTheming2.default)('mode', {
	  dark: color.lightBlueGray,
	  light: color.offWhite
	});
	var NavContainer = _styledComponents2.default.div(_templateObject, space.three, borderColor, function (props) {
	  return props.disabled && 'none';
	});
	
	var WorksNavigation = function WorksNavigation(_ref) {
	  var disabled = _ref.disabled;
	  return _react2.default.createElement(
	    NavContainer,
	    { disabled: disabled },
	    _react2.default.createElement(
	      _navigation.Navigation,
	      null,
	      _react2.default.createElement(
	        _navigation.NavigationItem,
	        { to: _routes2.default.mavenPro },
	        'Maven Pro'
	      )
	    )
	  );
	};
	
	exports.default = WorksNavigation;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-2721641f482e6f7f1f46.js